export default __webpack_public_path__ + "static/feature-flags-progressive-delivery-rilasci-incrementali-sicuri-astrorei-9ba0183330fc2d77497a1ea679eb2e05.jpg";